export function isMobile(): boolean 
{
    return !!window.localStorage.getItem('isMobile');
}